import React from 'react';
import { connect , useSelector } from 'react-redux';
import propTypes from 'prop-types';
import classNames from 'classnames';

// constants
import { applicationTypes } from 'constants/scripts';
import { selectIdPrefix } from 'constants/values';

// actions
import {
  addSeedProduct,
  removeSeedProductInput,
  openSeedProductSelectorModal,
  searchSeedProductsFromAutocompleteSelect,
  setSeedProductForScript,
  setSeedProductInput
} from 'current/uiwidgets';

import {
  updatePlantingPlanParams
} from 'planting-plan-form';


// selectors
import {
  canAddMoreSeedProductInputs,
  getActiveSeedProductInputs,
  getNumActiveSeedProductInputs,
  hasMaxNumOfSeedProductInputs as hasMaxNumOfSeedProductInputsFunc
} from 'current/selectors';
import { getActiveCropId } from 'current/currentSelectors';

import {
  getCurrentPath,
  isAdvancedRoute,
  isEditRoute,
  isManualRoute
} from 'routes/selectors';

// components
import AddSeedProductInputTrigger from 'triggers/AddSeedProductInputTrigger';
import RemoveSeedProductInputTrigger from 'triggers/RemoveSeedProductInputTrigger';
import SeedProductInputs from 'products/SeedProductInputs';
import SeedProductSelectorTrigger from 'triggers/SeedProductSelectorTrigger';
import { getCropBasedMessage } from 'util/locale';

const baseString = 'vra-seed-product-inputs-container';
let SeedProductInputsContainer = ({
  canAddMoreSeedProductInputs,
  hasMaxNumOfSeedProductInputs,
  isAdvancedRoute,
  isEditRoute,
  numSeedProductInputs,
  onChangeSearchQuery,
  onClickAddSeedProductInputTrigger,
  onClickSeedProductSelectorTrigger,
  onClickSelectRemoveTrigger,
  onSelectSeedProduct,
  seedProductInputs
}) => {
  const classString = classNames({
    [`${baseString}`]: true,
    'vra-planting-plan-form__inputs-wrapper': isAdvancedRoute
  });
  const cropId = useSelector(getActiveCropId);
  return (
    <section className={classString}>
      <SeedProductInputs
        numSeedProductInputs={numSeedProductInputs}
        onChangeSearchQuery={onChangeSearchQuery}
        onSelectSeedProduct={(params) => onSelectSeedProduct(params, isEditRoute)}
        seedProductInputs={seedProductInputs}
      />
      <SeedProductSelectorTrigger
        isVisible={isEditRoute}
        onClick={onClickSeedProductSelectorTrigger}
        triggerText={getCropBasedMessage({ key: 'button-text__open-seed-finder', cropId })}
      />
      <AddSeedProductInputTrigger
        isVisible={canAddMoreSeedProductInputs}
        onClick={onClickAddSeedProductInputTrigger}
        showHelpText={true}
        showPlus={true}
        showTooltip={false}
      />
      <RemoveSeedProductInputTrigger
        isVisible={hasMaxNumOfSeedProductInputs}
        onClick={(e) => onClickSelectRemoveTrigger(e, isEditRoute)}
      />
    </section>
  );
};
SeedProductInputsContainer.propTypes = {
  canAddMoreSeedProductInputs: propTypes.bool.isRequired,
  hasMaxNumOfSeedProductInputs: propTypes.bool.isRequired,
  isAdvancedRoute: propTypes.bool.isRequired,
  isEditRoute: propTypes.bool.isRequired,
  isManualRoute: propTypes.bool.isRequired,
  numSeedProductInputs: propTypes.number.isRequired,
  onChangeSearchQuery: propTypes.func.isRequired,
  onClickAddSeedProductInputTrigger: propTypes.func.isRequired,
  onClickSeedProductSelectorTrigger: propTypes.func.isRequired,
  onClickSelectRemoveTrigger: propTypes.func.isRequired,
  onSelectSeedProduct: propTypes.func.isRequired,
  seedProductInputs: propTypes.object.isRequired
};

SeedProductInputsContainer = connect(
  (state) => {
    const currentPath = getCurrentPath(state);
    return {
      canAddMoreSeedProductInputs: canAddMoreSeedProductInputs(state),
      hasMaxNumOfSeedProductInputs: hasMaxNumOfSeedProductInputsFunc(state),
      isAdvancedRoute: isAdvancedRoute(currentPath),
      isEditRoute: isEditRoute(currentPath),
      isManualRoute: isManualRoute(currentPath),
      numSeedProductInputs: getNumActiveSeedProductInputs(state),
      seedProductInputs: getActiveSeedProductInputs(state)
    };
  },
  (dispatch) => {
    return {
      onChangeSearchQuery: ({ fragment, selectId, receiveOptions }) =>
        dispatch(searchSeedProductsFromAutocompleteSelect({ fragment, selectId, receiveOptions })),
      onClickAddSeedProductInputTrigger: () => dispatch(addSeedProduct()),
      onClickSeedProductSelectorTrigger: (e) => {
        e.target.blur();
        dispatch(openSeedProductSelectorModal());
      },
      onClickSelectRemoveTrigger: (e, isEditRoute) => {
        e.preventDefault();
        if (isEditRoute) {
          dispatch(removeSeedProductInput({ selectId: `${selectIdPrefix}2` }));
        } else {
          dispatch(updatePlantingPlanParams({products: {[applicationTypes.SEED]: {[`${selectIdPrefix}2`]: null} }}));
        }
        dispatch(setSeedProductInput({ active: false, currentProductId: null, selectId: `${selectIdPrefix}2` }));
      },
      onSelectSeedProduct: ({ currentProductId, products, selectId, oldProductId }, isEditRoute) => {
        if (isEditRoute) {
          dispatch(setSeedProductForScript({ currentProductId, oldProductId }));
        } else {
          dispatch(updatePlantingPlanParams({products: {[applicationTypes.SEED]: {[selectId]: currentProductId} }}));
        }
        dispatch(setSeedProductInput({ currentProductId, products: products[selectId].products, selectId }));
      }
    };
  }
)(SeedProductInputsContainer);
export default SeedProductInputsContainer;
